import moduleLinks from '../config/links';
import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { isArray, keyBy } from 'lodash';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { defaultLocale } from 'configs/locale.js';

const path = 'tube/';
const initialState = Object.assign({ data: keyBy(moduleLinks, 'id') }, { timer: undefined });
const FETCH_LINK_COUNT = `${path}FETCH_LINK_COUNT`;
const START_TIMER = `${path}START_TIMER`;
const STOP_TIMER = `${path}STOP_TIMER`;
const FETCH_MAYO_FORM_URL = `${path}FETCH_MAYO_FORM_URL`;
const FETCH_MAYO_REPORT_URL = `${path}FETCH_MAYO_REPORT_URL`;

const reducer = {
  [START_TIMER]: (state, action) => {
    return Object.assign({}, state, { timer: action.timer });
  },
  [STOP_TIMER]: (state) => {
    clearInterval(state.timer);
    return Object.assign({}, state, { timer: undefined });
  },
  [FETCH_MAYO_FORM_URL]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true });
    },
    [SUCCESS]: (state, action) => {
      const newData = Object.assign({}, state.data, {
        mayoForm: Object.assign({}, state.data.mayoForm, {
          url: action.payload.data.data,
        }),
      });
      return Object.assign({}, state, { data: newData, isLoading: false });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false });
    },
  },
  [FETCH_MAYO_REPORT_URL]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true });
    },
    [SUCCESS]: (state, action) => {
      const newData = Object.assign({}, state.data, {
        mayoReport: Object.assign({}, state.data.mayoReport, {
          url: action.payload.data.data,
        }),
      });
      return Object.assign({}, state, { data: newData, isLoading: false });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false });
    },
  },
};

moduleLinks.forEach((link) => {
  reducer[`${FETCH_LINK_COUNT}_${link.id}`] = {
    [SUCCESS]: (state, action) => {
      const links = state.data;

      if (links[link.id] === undefined) {
        return state;
      }

      links[link.id] = Object.assign({}, links[link.id], { count: action.payload.data.data });
      return Object.assign({}, state, { data: links });
    },
  };
});

export default typeToReducer(reducer, initialState);

export function fetchLinksCount() {
  return (dispatch, getState) => {
    const links = getState().app.tube.index.links.data;
    const allPermissions = getState().permission.allPermissions;
    const permissionsSet = new Set(allPermissions.map((p) => p.functionCode));

    /**
     * 檢查 user 是否有 MayoForm icon 權限（'MayoFormPersonal', 'MayoFormHR'）
     * 有權限才需要打 messageApi（沒有權限就從 links 剔出 mayoForm 項目）
     */
    const MAYO_FORM_PERSONAL_FUNCTION_CODE = 'MayoFormPersonal';
    const MAYO_FORM_HR_FUNCTION_CODE = 'MayoFormHR';
    const filteredLinks = Object.entries(links).reduce((acc, [key, link]) => {
      // Keep all non-mayoForm links
      if (key !== 'mayoForm') {
        acc[key] = link;
        return acc;
      }

      const { functionCode } = link;

      // Remove if functionCode is missing
      if (!functionCode) return acc;

      // Remove if user lacks both required permissions
      if (
        !permissionsSet.has(MAYO_FORM_PERSONAL_FUNCTION_CODE) &&
        !permissionsSet.has(MAYO_FORM_HR_FUNCTION_CODE)
      ) {
        return acc;
      }

      // Check if functionCode matches either permission (supports string or array)
      const isValid =
        functionCode === MAYO_FORM_PERSONAL_FUNCTION_CODE ||
        functionCode === MAYO_FORM_HR_FUNCTION_CODE ||
        (isArray(functionCode) &&
          (functionCode.includes(MAYO_FORM_PERSONAL_FUNCTION_CODE) ||
            functionCode.includes(MAYO_FORM_HR_FUNCTION_CODE)));

      if (!isValid) return acc; // Remove if no valid functionCode

      // Keep the mayoForm link if it passed all checks
      acc[key] = link;
      return acc;
    }, {});

    Object.values(filteredLinks).forEach((link) => {
      if (link.messageApi) {
        dispatch({
          type: `${FETCH_LINK_COUNT}_${link.id}`,
          payload: axios.get(link.messageApi),
        });
      }
    });
  };
}

export function startLinkCountTimer() {
  return (dispatch) => {
    dispatch(fetchLinksCount());
    const timer = setInterval(() => {
      dispatch(fetchLinksCount());
    }, 600000);
    return dispatch({
      type: START_TIMER,
      timer,
    });
  };
}

export function stopLinkCountTimer() {
  return {
    type: STOP_TIMER,
  };
}

export function fetchMayoFormUrl(locale = defaultLocale) {
  return {
    type: FETCH_MAYO_FORM_URL,
    payload: axios.get('/Authorization/GetFlowUrl', {
      params: {
        targetbpm: 'mayoform',
        targetPath: 'bpm/applyform',
        lang: locale,
      },
    }),
  };
}

export function fetchMayoReportUrl(locale = defaultLocale) {
  return {
    type: FETCH_MAYO_REPORT_URL,
    payload: axios.get('/Authorization/GetFlowUrl', {
      params: {
        targetbpm: 'mayoreport',
        targetPath: 'bpm/applyform',
        lang: locale,
      },
    }),
  };
}

// 檔期津貼 BonusCalc 不走 GetFlowUrl（OPTI-142）：
// Mayo.Tube.Authorization 的 HandleGetFlowUrl 只分派 GAIA Form 與 Apollo BPM Bridge 兩條路，
// 傳 targetbpm='bonuscalc' 會落入 BPM Bridge 分支而取不到檔期津貼站台位址。
// BonusCalc 與 Apollo 同在 mayohr.com 網域、自行驗證 Asia Cookie（主單 OPTI-134 WP5），
// 因此前端直接開 url.BONUS_CALC_WEBSITE 即可，不需要換票。



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/reducers/linkReducer.js
 **/